export function AppleStoreIcon({ className = "size-4 shrink-0" }) {
  return (
    <svg
      viewBox="0 0 24 24"
      className={className}
      aria-hidden="true"
      fill="currentColor"
    >
      <path d="M18.71 19.5c-.83 1.24-1.71 2.45-3.05 2.47-1.34.03-1.77-.79-3.29-.79-1.53 0-2 .77-3.27.82-1.31.05-2.3-1.32-3.14-2.53C4.25 17 2.94 12.45 4.7 9.39c.87-1.52 2.43-2.48 4.12-2.51 1.28-.02 2.5.87 3.29.87.78 0 2.26-1.07 3.81-.91.65.03 2.47.26 3.64 1.98-.09.06-2.17 1.28-2.15 3.81.03 3.02 2.65 4.03 2.68 4.04-.03.07-.42 1.44-1.38 2.83M13 3.5c.73-.83 1.94-1.46 2.94-1.5.13 1.17-.34 2.35-1.04 3.19-.69.85-1.83 1.51-2.95 1.42-.15-1.15.41-2.35 1.05-3.11z" />
    </svg>
  );
}

export function GooglePlayIcon({ className = "size-4 shrink-0" }) {
  return (
    <svg viewBox="0 0 24 24" className={className} aria-hidden="true">
      <path fill="#00D2FF" d="M1.5 2.1v19.8l11.1-9.9z" />
      <path fill="#00F076" d="M12.6 12 20.8 4.9c.4-.3.9-.5 1.4-.5v15.2c-.5 0-1-.2-1.4-.5z" />
      <path fill="#FF3A44" d="M1.5 2.1 12.6 12 1.5 21.9z" />
      <path fill="#FFB900" d="M12.6 12 20.8 19.1c.4.3.9.5 1.4.5V4.4c-.5 0-1 .2-1.4.5z" />
    </svg>
  );
}

export function StoreBrandIcon({ store, className }) {
  if (store === "ios") {
    return <AppleStoreIcon className={className} />;
  }
  return <GooglePlayIcon className={className} />;
}
